import React from 'react';
import './test.css'
import { Link } from 'react-router-dom';
const TestConfirm = () => {

  
  return (
    <div id='testconfirm'>
      <div className=" d-flex justify-content-center flex-column w-100 mx-auto align-items-center mt-5 mb-5  py-4 ">

<div className="test-msg w-sm-75 w-md-50 position-relative ">
   <div className="top-layer position-absolute">

   </div>

   <div className="test-msg-content text-center  px-5 w-100 py-5 mt-5">
       <p className='fs-4'>Are you ready to answer our questions?</p>
       <Link to='/test/testquestion' className="btn btn-primary rounded-pill text-white px-4 py-2 mt-5 ">continue</Link>
   </div>
</div> 

</div>

    </div>
  );
}

export default TestConfirm;
